<!-- 考证题目设置 -->
<template>
  <div class="el-HomeworkAdd">
    <el-row class="mb20">
      <el-col :span="3" class="t_r">
        <p>题目名称：</p>
      </el-col>
      <el-col :span="21">
        <el-input style="width: 400px;" v-model="form.generalQuestionSettingName"></el-input>
      </el-col>
    </el-row>
    <el-row class="mb20">
      <el-col :span="3" class="t_r">
        <p>题目班级：</p>
      </el-col>
      <el-col :span="21">
        <el-select v-model="classIds" style="width: 400px;" clearable multiple collapse-tags filterable placeholder="请选择">
          <template v-for="(item ,index) in classList">
            <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
          </template>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="mb20">
      <el-col :span="3" class="t_r">
        <p>题目时间：</p>
      </el-col>
      <el-col :span="21">
        <el-date-picker
          v-model="time"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-col>
    </el-row>
    <el-row class="mb20">
      <el-col :span="3" class="t_r">
        <p>题目设置：</p>
      </el-col>
      <el-col :span="21" style="background-color: #EBEEF5;padding: 10px 20px;">
        <el-row class="mb10">
          <label>作答次数</label>
          <el-input style="width: 200px;margin-left: 10px;" v-model="form.generalQuestionSettingDoCount"></el-input>
        </el-row>
        <el-row class="mb10">
          <el-col :span="12">
            <label style="width: 170px;float: left;text-align: right;margin-right: 10px;">题目乱序（同一大题内）：</label>
            <el-radio v-model="form.generalQuestionSettingQuestionNoOrder" label="1">是</el-radio>
            <el-radio v-model="form.generalQuestionSettingQuestionNoOrder" label="2">否</el-radio>
          </el-col>
          <el-col :span="12">
            <label style="width: 170px;float: left;text-align: right;margin-right: 10px;">选项乱序（同一大题内）：</label>
            <el-radio v-model="form.generalQuestionSettingOptionNoOrder" label="1">是</el-radio>
            <el-radio v-model="form.generalQuestionSettingOptionNoOrder" label="2">否</el-radio>
          </el-col>
        </el-row>
        <el-row class="mb10">
          <el-col :span="12">
            <label style="width: 170px;float: left;text-align: right;margin-right: 10px;">答卷后显示答案解析：</label>
            <el-radio v-model="form.generalQuestionSettingEndShowQa" label="1">是</el-radio>
            <el-radio v-model="form.generalQuestionSettingEndShowQa" label="2">否</el-radio>
          </el-col>
          <el-col :span="12">
            <label style="width: 170px;float: left;text-align: right;margin-right: 10px;">答卷后显示答案对错：</label>
            <el-radio v-model="form.generalQuestionSettingEndShowTrueFalse" label="1">是</el-radio>
            <el-radio v-model="form.generalQuestionSettingEndShowTrueFalse" label="2">否</el-radio>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="mb20">
      <el-col :span="3" class="t_r">
        <p>题目设置：</p>
      </el-col>
      <el-col :span="21">
        <el-button type="primary" icon="el-icon-folder-opened" @click="selectQuestion">手动出题</el-button>
        <el-button type="success" icon="el-icon-refresh" @click="randomQuestion">随机抽题</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        :data="questionSettingOptions"
        border
        style="width: 100%">
        <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
        <el-table-column prop="questionType" header-align="center" align="center" label="题型">
          <template slot-scope="scope">{{$retQuestionType(scope.row.questionType)}}</template>
        </el-table-column>
        <el-table-column prop="totalCount" header-align="center" align="center" label="总数量"> </el-table-column>
        <el-table-column prop="selectCount" header-align="center" align="center" label="选题量">
          <template slot-scope="scope">
            <el-input :disabled="addType == 1" v-model.number="scope.row.selectCount" @change="calculationScore(scope.row)" placeholder="请输入题数"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="singleScore" header-align="center" align="center" label="分值">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.singleScore" @change="calculationScore(scope.row)" placeholder="请输入分值数"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="singleTypeTotalScore" header-align="center" align="center" label="合计"></el-table-column>
      </el-table>
    </el-row>

    <!-- 选择题库 -->
    <Question
      :show="seeQuestionShow"
      @closeDialog="value => seeQuestionShow = true"
      @onSuccess="submitSeeQuestion"
      :courseId="courseId"
      :onIds="form.resourcesQuestionIdPlural"
      v-if="seeQuestionShow">
    </Question>

    <!-- 随机出题 -->
    <el-dialog
      title="随机出题"
      :visible.sync="randomQuestionShow"
      :append-to-body="true"
      width="680px"
    >
      <span slot="title">
        <i class="el-icon-s-check" style="margin-right: 10px;color: #67C23A;"></i>随机出题
      </span>
      <el-row class="mb10" v-for="(item ,index) in questionList" :key="index">
        <label>{{$retQuestionType(item.questionType)}}：</label>
        <el-input v-model.number="questionList[index].selectCount" style="width: 120px;margin-right: 10px;" @change="calculationScore(item)" placeholder="请输入题数"></el-input>
        <label>道</label>
        <label class="ml50">分值：</label>
        <el-input v-model.number="questionList[index].singleScore" style="width: 120px;margin-right: 10px;" @change="calculationScore(item)" placeholder="请输入分值"></el-input>分/道
        <label class="ml30" style="color: #409eff;">
          总题数：{{item.totalCount}}
        </label>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="randomQuestionShow = false">取 消</el-button>
        <el-button type="primary" @click="submitRandomQuestion">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Question from '@/components/Question/coachIndex';
export default {
  name: "HomeworkAdd",
  components: {
    Question,
  },
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    },
    classList: { //班级List
      type: Array,
      required:true
    },
    homeInfo: { //编辑时使用
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      ct_b:require("../../images/course/ct_b@2x.png"),
      time:[],
      classIds:[],
      questionSettingOptions:[],
      form:{
        generalQuestionSettingName:"",
        generalQuestionSettingQuestionNoOrder:"1",
        generalQuestionSettingOptionNoOrder:"1",
        generalQuestionSettingEndShowQa:"1",
        generalQuestionSettingEndShowTrueFalse:"1",
        resourcesQuestionIdPlural:"" //
      },
      searchQ:{},
      seeQuestionShow:false,
      randomQuestionShow:false, //随机出题
      questionList:[],
      questionTypeGroupInfoList:[], //题型List
      questionTypeMap:[], //题型Map {题型：总数}
      addType:1, //题型添加类型 1：手动 2：随机
    };
  },
  created() {
    this.questionTypeGroupInfo();
    if(Object.keys(this.homeInfo).length > 0){
      this.form = {
        generalQuestionSettingDoCount:this.homeInfo.generalQuestionSettingDoCount,
        generalQuestionSettingName:this.homeInfo.generalQuestionSettingName,
        generalQuestionSettingQuestionNoOrder:this.homeInfo.generalQuestionSettingQuestionNoOrder+"",
        generalQuestionSettingOptionNoOrder:this.homeInfo.generalQuestionSettingOptionNoOrder+"",
        generalQuestionSettingEndShowQa:this.homeInfo.generalQuestionSettingEndShowQa+"",
        generalQuestionSettingEndShowTrueFalse:this.homeInfo.generalQuestionSettingEndShowTrueFalse+"",
        resourcesQuestionIdPlural:this.homeInfo.resourcesQuestionIdPlural,
        generalQuestionSettingId:this.homeInfo.generalQuestionSettingId
      }
      //题目
      if(!this.$isEmpty(this.homeInfo.generalQuestionStartTime) && !this.$isEmpty(this.homeInfo.generalQuestionEndTime)){
        this.time = [this.homeInfo.generalQuestionStartTime,this.homeInfo.generalQuestionEndTime];
      }
      //班级
      if(!this.$isEmpty(this.homeInfo.generalQuestionSettingSchoolClassIds)){
        this.classIds = this.homeInfo.generalQuestionSettingSchoolClassIds.split(",");
      }
      this.questionSettingOptions = this.homeInfo.questionSettingOptions;
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo(){ //获取列表

    },
    selectQuestion(){ //题库选择
      this.seeQuestionShow = Object.assign(false, true);
    },
    submitSeeQuestion(ids){ //确认题库选择
      this.form.resourcesQuestionIdPlural = ids;
      if(this.$isEmpty(ids)){
        this.questionSettingOptions = [];
        return;
      }
      let param = {problemIds:this.form.resourcesQuestionIdPlural}
      this.$get("/jlw/generalHandsOnSimulationTasks/getObjectiveProblem.do",param).then((ret) =>{
        this.questionSettingOptions = [];
        ret.forEach((item,i)=>{
          item.questionType = this.$retQuestionType(item.questionType,1);
          item.totalCount = this.questionTypeMap[this.$retQuestionType(item.questionType,1)];
          item.selectCount = item.questionNum;
          item.singleScore = item.questionScore;
          item.singleTypeTotalScore = (item.questionNum || 0) * (item.questionScore || 0);
          this.questionSettingOptions.push(item);
          this.addType = 1;
        });
      });
    },
    randomQuestion(){ //随机出题
      this.questionList = [];
      this.randomQuestionShow = true;
      if(this.questionSettingOptions <= 0){
        this.questionList = this.questionTypeGroupInfoList;
      }else{
        let questionType = {}; //创建存储已存在的题目类型
        this.questionSettingOptions.forEach((item,i)=>{
          questionType[item.questionType] = 1;
          this.questionList[i] = Object.assign({}, item);
        });
        this.questionTypeGroupInfoList.forEach((item,i)=>{
          if(questionType[item.questionType] != 1){
            this.questionList.push(item);
          }
        });
        this.questionList = Object.assign([], this.questionList);
      }
    },
    submitRandomQuestion(){ //确认随机出题
      let listInfo = [];
      try {
        this.questionList.forEach((item,i)=>{
          if(!this.$isEmpty(item.selectCount) && !this.$isEmpty(item.singleScore)){
            listInfo.push(item);
          }
          if((!this.$isEmpty(item.selectCount) || !this.$isEmpty(item.singleScore)) && (this.$isEmpty(item.selectCount) || this.$isEmpty(item.singleScore))){
            throw new Error('请完善'+ this.$retQuestionType(item.questionType) +"的信息！");
          }
        });
      } catch (e) {
        this.$message.warning(e.message);
        return
      };
      if(listInfo.length <= 0){
        this.$message.warning("请输入抽题信息");
        return;
      }
      this.questionSettingOptions = Object.assign([], listInfo);
      this.randomQuestionShow = false;
      this.addType = 2;
      this.form.resourcesQuestionIdPlural = "";
      this.$message({type: 'success',message: '出题成功！'});
    },
    questionTypeGroupInfo(){
      this.$post("/api/resourcesQuestion/questionTypeGroupInfo.do",{generalId:this.courseId}).then((ret) =>{
        if(ret.code == 0){
          this.questionTypeGroupInfoList = ret.data;
          this.questionTypeGroupInfoList.forEach((item,i)=>{
            this.questionTypeMap[item.questionType] = item.totalCount;
          });
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    calculationScore(item){ //计算总分值
      item.singleTypeTotalScore = (item.selectCount || 0) * (item.singleScore || 0);
    }
  }
};
</script>
 <style  lang="less">
  .el-HomeworkAdd{

  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/certificate/HomeworkAdd.vue